import { render, staticRenderFns } from "./SuggestionsCard.vue?vue&type=template&id=34b97f25&scoped=true&"
import script from "./SuggestionsCard.vue?vue&type=script&lang=js&"
export * from "./SuggestionsCard.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionsCard.vue?vue&type=style&index=0&id=34b97f25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b97f25",
  null
  
)

/* custom blocks */
import block0 from "./SuggestionsCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports